import type { SocialProfileType } from '@/types/socialProfileType';

type SortSocialProfilesType = 'sort_asc' | 'sort_desc' | 'sort_selected' | 'sort_unselected';

type SocialProfileSortType = SocialProfileType & {
    selected: boolean;
};

// function sort
export function sortSocialProfiles<TProfile extends SocialProfileSortType>(
    type: SortSocialProfilesType,
    profileA: TProfile,
    profileB: TProfile
) {
    if (type === 'sort_selected' || type === 'sort_unselected') {
        if (profileA.selected === profileB.selected) {
            return profileA.slug.localeCompare(profileB.slug);
        }

        if (type === 'sort_selected') {
            return profileA.selected ? -1 : 1;
        }

        return profileA.selected ? 1 : -1;
    }

    if (type === 'sort_asc') {
        return profileA.slug.localeCompare(profileB.slug);
    }

    return profileB.slug.localeCompare(profileA.slug);
}
